module.exports = __webpack_public_path__ + "static/media/gilead.2184b552.jpg";